<script lang="ts">
    import type {ComponentStyle} from '../types';

    export let panelStyle: ComponentStyle = 'default';
    export let additionalClasses = '';
    export let hasBodyPadding = true;
    export let hasBorder = true;
</script>

<div class="panel panel-{panelStyle} {additionalClasses}"
     class:no-border-panel={!hasBorder}>

    {#if $$slots.heading}
        <div class="panel-heading">
            <slot name="heading"/>
        </div>
    {/if}

    <div class="panel-body" class:no-padding-panel-body={!hasBodyPadding}>
        <slot/>
    </div>

    {#if $$slots.footer}
        <div class="panel-footer">
            <slot name="footer"/>
        </div>
    {/if}
</div>

<style lang="less">
    .no-border-panel {
        border: none;
    }

    .no-padding-panel-body {
        box-shadow: none;
        padding: 0;
    }
</style>